/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="12"
        height="32"
        viewBox="0 0 12 32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M10.05 30.1 1.17 14.23 10.05 1"
          stroke="#4a4a4a"
          style={{ fill: 'none' }}
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"/>
      </svg>

    );
  }
}

Icon.displayName = 'ChevronLeftNarrowIcon';

export default Icon;
